import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, UseFormProps } from 'react-hook-form';
import { z } from 'zod';

export const useReactForm = <T extends z.ZodObject, C = unknown>({
  schema,
  ...props
}: {
  schema: T;
} & Omit<UseFormProps<z.output<T>>, 'resolver'>) => {
  return useForm({
    mode: 'onChange',
    ...props,
    resolver: zodResolver(schema) as unknown as UseFormProps<
      z.output<T>,
      C,
      z.output<T>
    >['resolver'],
  });
};
